
const base = {
    //logo: 'logo.png',
    logo : 'logo.png',
    icons: 'https://tech2us.ma/content/icons/',
    title: 'health.digitalservices.ma',
    name: 'Healthier'
}

const icons = {
    add : base.icons+'add.png',
    reload : base.icons+'reload.png',
    minimize : base.icons+'minimize.png',
    maximize : base.icons+'maximize.png'
}

const bank = {
    Company: 'TECH2US',    
    RIB : '366 810 0117109 100050838 01',
    Name: 'BANK AL YOUSR',
}

export {base, icons, bank}